import React from 'react'
import { Link } from 'react-router-dom'

const Cart = () => {
  return (
    <section className="cart-section">
    <div className="auto-container">
      {/*Cart Outer*/}
      <div className="cart-outer">
        <div className="table-outer">
          <table className="cart-table">
            <thead className="cart-header">
              <tr>
                <th className="prod-column">Product</th>
                <th className="price">Price</th>
                <th>Quantity</th>
                <th>Total</th>
                <th>Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="prod-column">
                  <div className="column-box">
                    <figure className="prod-thumb">
                      <Link  to="#">
                        <img src="/assets/images/resource/products/thumb-1.jpg" alt="" />
                      </Link> 
                    </figure>
                    <h6 className="prod-title">Modern Basket</h6>
                  </div>
                </td>
                <td className="price">$130.00</td>
                <td className="qty">
                  <input
                    className="quantity-spinner"
                    type="text"
                    defaultValue={2}
                    name="quantity"
                  />
                </td>
                <td className="sub-total">$260.00</td>
                <td className="remove">
                  <Link  to="#" className="remove-btn">
                    <span className="fa fa-times" />
                  </Link> 
                </td>
              </tr>
              <tr>
                <td className="prod-column">
                  <div className="column-box">
                    <figure className="prod-thumb">
                      <Link  to="#">
                        <img src="/assets/images/resource/products/thumb-2.jpg" alt="" />
                      </Link> 
                    </figure>
                    <h6 className="prod-title">AB Package</h6>
                  </div>
                </td>
                <td className="price">$90.00</td>
                <td className="qty">
                  <input
                    className="quantity-spinner"
                    type="text"
                    defaultValue={2}
                    name="quantity"
                  />
                </td>
                <td className="sub-total">$90.00</td>
                <td className="remove">
                  <Link  to="#" className="remove-btn">
                    <span className="fa fa-times" />
                  </Link> 
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="coupon-outer clearfix">
          <div className="pull-left">
            <div className="apply-coupon clearfix">
              <div className="form-group clearfix">
                <input
                  type="text"
                  name="coupon-code"
                  defaultValue=""
                  placeholder="Coupon Code"
                />
              </div>
              <div className="form-group clearfix">
                <button
                  type="button"
                  className="theme-btn coupon-btn btn-style-one"
                >
                  <span className="txt">Apply Coupon</span>
                </button>
              </div>
            </div>
          </div>
          <div className="pull-right">
            <button type="button" className="theme-btn btn-style-one">
              <span className="txt">Update Cart</span>
            </button>
          </div>
        </div>
        {/*Cart Total Box*/}
        <div className="cart-total-box">
          <h4>Cart Totals</h4>
          {/*Totals Table*/}
          <ul className="totals-table">
            <li className="clearfix">
              <span className="col col-title">Subtotal</span>
              <span className="col">$350.00</span>
            </li>
            <li className="clearfix">
              <span className="col col-title">Tax</span>
              <span className="col">$15.00</span>
            </li>
            <li className="total clearfix">
              <span className="col col-title">Total .</span>
              <span className="col">$365.00</span>
            </li>
          </ul>
        </div>
        <div className="text-left">
          <button type="submit" className="theme-btn checkout-btn">
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Cart